module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0Ij4KCTxjaXJjbGUgY3g9IjMyIiBjeT0iMzIiIHI9IjI1IiBzdHJva2U9InJlZCIgc3Ryb2tlLXdpZHRoPSI3IiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwLjIiLz4KCTxyZWN0IHg9IjI4IiB5PSI3IiB3aWR0aD0iOCIgaGVpZ2h0PSI1MCIgZmlsbD0icmVkIiB0cmFuc2Zvcm09InJvdGF0ZSg0NSwgMzIsIDMyKSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./node_modules/blueimp-gallery/img/error.svg
// module id = ZhkF
// module chunks = 2 3